// Real Yalola logo for canvas share posters. Same-origin asset (/yalola-logo.png)
// → drawing it never taints the canvas (toBlob keeps working, web AND native).
let _img = null;
let _started = false;

export const preloadBrandLogo = () => {
  if (_started || typeof Image === "undefined") return;
  _started = true;
  const im = new Image();
  im.onload = () => { _img = im; };
  im.onerror = () => { _started = false; };
  im.src = "/yalola-logo.png";
};

// Draw the brandmark centered at (cx, cy): the real logo when loaded,
// otherwise the legacy gold "Y" disc as fallback.
export const drawBrandMark = (ctx, cx, cy, r = 56) => {
  preloadBrandLogo();
  if (_img) {
    ctx.drawImage(_img, cx - r, cy - r, r * 2, r * 2);
    return;
  }
  ctx.fillStyle = "#E0A63C";
  ctx.beginPath(); ctx.arc(cx, cy, r, 0, Math.PI * 2); ctx.fill();
  ctx.fillStyle = "#0E1A14"; ctx.font = `bold ${Math.round(r * 1.14)}px Outfit, Arial, sans-serif`;
  ctx.textAlign = "center"; ctx.textBaseline = "middle"; ctx.fillText("Y", cx, cy + 2);
};

preloadBrandLogo();
